import api from '..';
import mutationFactory from './mutationFactory';
import useResourceList from './useResourceList';

export const useUsersList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'users', api: api.users }, queryVariables, queryConfig);

  return {
    users: queryResult.resolvedData,
    latestUsers: queryResult.latestData,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'users' });

export const useUpdateUser = createMutation(api.users.update);
